import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';
import { getScreens, type IScreensReadParams } from 'shared/src/api';
import { useFilterListAtom } from 'shared/src/component';

export const useGetScreensInfiniteQuery = (
  screenName: string,
  nextToken?: string,
) => {
  const {
    filterListAtomValue: { ...restFilterListAtomValue },
  } = useFilterListAtom();

  return useInfiniteQuery({
    queryKey: [
      'getScreens',
      { ...restFilterListAtomValue, nextToken, screen_name: screenName },
    ],
    queryFn: ({ pageParam }) => {
      const requestParams = {
        ...restFilterListAtomValue,
        next_token: pageParam ?? null,
        screen: screenName,
      } as IScreensReadParams;
      return getScreens(requestParams);
    },
    enabled: true,
    initialPageParam: nextToken ?? null,
    getNextPageParam: lastPage => {
      return lastPage.nextToken || undefined;
    },
    select: data => {
      const components = data.pages.flatMap(page => page.components);
      const formattedData = {
        ...data.pages[data.pages.length - 1],
        components,
      };

      return formattedData;
    },
    placeholderData: keepPreviousData,
  });
};
